import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../services/login.service';
import { GlobalService } from '../../../services/global.service';
import { AlertsService } from '../../../services/alerts.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  email: string = '';
  password: string = '';
  isLogged: boolean = false;

  constructor (  
    public loginService: LoginService,
    private global: GlobalService,
    private alerts: AlertsService,
    private router: Router
    ) { 
    this.global.setDocumentTitle( 'Login' );
  }

  ngOnInit ( ) {
    this.isLogged = this.loginService.check( );
    if ( this.isLogged ) this.router.navigate(['/']);
  }

  customAlert ( data ) {
    this.alerts.setData( data ).subscribe( );
  }

  successLogin ( _this ) {
    _this.alerts.clearData( ).subscribe( );
  }

  errorLogin ( _this ) {
    let _data = {
      messageType: 'error',
      message: 'Incorrect email and/or password',
      title: 'Error'
    };
    _this.customAlert( _data );
  }

  login ( ) {
      this.loginService.login( 
        this.email, 
        this.password, 
        this.successLogin, 
        this.errorLogin,
        this
        );
      return false;
  }



}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/defaults/login/login.component.ts